module.exports = __webpack_public_path__ + "img/ENI_120X35.c3dd621e.png";